<script setup>
import {onMounted, ref} from "vue";
import IconChevron from "../icons/iconChevron.vue";

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: ''
    },
    contentClass: {
        type: String,
        required: false,
        default: ''
    },
    foldingEnabled: {
        type: Boolean,
        required: false,
        default: true
    },
    borderBottom: {
        type: Boolean,
        required: false,
        default: false
    }
})

const expanded = ref(false)

onMounted(() => {
    if (!props.foldingEnabled) {
        expanded.value = true;
    }
})
</script>

<template>
    <div>
        <div
            class="flex items-center justify-between space-x-2 group fill-sidebar-padding"
            :class="[expanded ? 'bg-gradient-to-b from-transparent via-transparent to-gray-100' : '', borderBottom && !expanded ? 'border-b' : '']"
        >
            <h5
                @click="expanded = !expanded"
                class="w-full cursor-pointer py-3"
            >
                {{ title }}
            </h5>
            <button-transparent
                v-if="props.foldingEnabled"
                @click="expanded = !expanded"
            >
                <icon-chevron
                    class="h-4 w-4 transition-all group-hover:text-wlPrimary"
                    :class="expanded ? 'rotate-180' : ''"
                />
            </button-transparent>
        </div>
        <div
            v-if="expanded"
            class="pt-2 pb-6 fill-sidebar-padding py-4"
            :class="[expanded ? 'bg-gray-100' : '', borderBottom && expanded ? 'border-b' : '']"
        >
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>

</style>
